import { Component, OnDestroy, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatRippleModule } from '@angular/material/core';
import { NgIf } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { pageTransitions } from '../../../shared/animations/page-transitions';
import { ScheduleBusinessOrderService }
	from '../../services/schedule-business-order.service';
import { FieldOfScheduleBusinessOrderAggregate, ScheduleBusinessOrderAggregate }
	from '../../models/aggregation/schedule-business-order-aggregate';
import { NumberPipe } from '../../../shared/pipes/number.pipe';
import { LoadingSpinnerComponent } from '../../../shared/components/utils/loading-spinner.component';

@Component({
	selector: 'copo-schedule-business-order-situation',
	templateUrl: './schedule-business-order-situation.component.html',
	styleUrl: './schedule-business-order-situation.component.css',
	encapsulation: ViewEncapsulation.Emulated,
	animations: pageTransitions,
	imports: [
		TranslateModule,
		NgIf,
		MatRippleModule,
		MatIconModule,
		LoadingSpinnerComponent,

		MatButtonModule,
		NumberPipe
	]
})
export class ScheduleBusinessOrderSituationComponent implements OnDestroy {
	scheduleBusinessOrderQuantities?: ScheduleBusinessOrderAggregate;
	isLoading = true;
	private readonly fields: readonly FieldOfScheduleBusinessOrderAggregate[] = [
		'grossQtyInProduction',
		'grossQtyAvailableReadyToShip',
		'grossQtyAvailableInTransit',
		'grossQtyAvailableInConsignment',
		'grossQtyBlocked'
	];

	private readonly scheduleBusinessOrderAggregateSub: Subscription;

	constructor(
		private readonly scheduleBusinessOrdersService: ScheduleBusinessOrderService,
		private readonly router: Router
	) {
		this.scheduleBusinessOrderAggregateSub = this.scheduleBusinessOrdersService
			.getScheduleBusinessOrderAggregateQuantity(this.fields).subscribe({
				next: value => {
					this.scheduleBusinessOrderQuantities = value[0];
					this.isLoading = false;
				},
				error: (err: unknown) => {
					console.error('error loading schedule business order situation', err);
					this.isLoading = false;
				}
			});
	}

	async viewDetails(filter?: string) {
		await this.router.navigateByUrl('/order-tracking/schedule-business-order/datacenter', filter ? {
			state: {
				filter: [
					{
						id: 'scheduleBusinessOrdersWithMaterial',
						values: [
							[
								{
									apiName: 'qtyInProduction',
									selected: filter === 'qtyInProduction'
								},
								{
									apiName: 'qtyAvailableReadyToShip',
									selected: filter === 'qtyAvailableReadyToShip'
								},
								{
									apiName: 'qtyAvailableInTransit',
									selected: filter === 'qtyAvailableInTransit'
								},
								{
									apiName: 'qtyAvailableInConsignment',
									selected: filter === 'qtyAvailableInConsignment'
								},
								{
									apiName: 'qtyBlocked',
									selected: filter === 'qtyBlocked'
								}
							]
						]
					}
				]
			}
		} : undefined);
	}

	ngOnDestroy() {
		this.scheduleBusinessOrderAggregateSub.unsubscribe();
	}
}
